import { loadingContent } from '@src/constants';

export default function LoadingContent({
  description = loadingContent.description,
}: {
  description?: string;
}) {
  return (
    <div
      className="flex h-[400px] flex-col items-center justify-center gap-6"
      role="status"
      aria-live="polite"
    >
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-primary-100 border-b-primary-900 dark:border-dark-neutral-700 dark:border-b-white"
        aria-hidden="true"
      />
      <p className="body14 max-w-[278px] text-center font-medium dark:text-gray-100">
        {description}
      </p>
    </div>
  );
}
